(function () {
  function formatDate(date) {
    var weekdays = ['søn.', 'man.', 'tir.', 'ons.', 'tor.', 'fre.', 'lør.'];
    var months = ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'];
    return weekdays[date.getDay()] + ' ' + date.getDate() + '. ' + months[date.getMonth()];
  }

  function renderShippingDate() {
    var date = new Date();
    date.setDate(date.getDate() + 2);
    var label = formatDate(date);
    document.querySelectorAll('[data-hh-sg-date]').forEach(function (node) {
      node.textContent = label;
      node.setAttribute('data-hh-sg-rendered', 'true');
    });
  }

  function enableReveals() {
    var root = document.getElementById('hh-sg-page');
    if (!root || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.classList.add('hh-sg-motion');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('hh-sg-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    root.querySelectorAll('[data-hh-sg-reveal]').forEach(function (node) { observer.observe(node); });
  }

  document.addEventListener('DOMContentLoaded', function () { renderShippingDate(); enableReveals(); });
  document.addEventListener('shopify:section:load', function () { renderShippingDate(); enableReveals(); });
  document.addEventListener('shopify:section:select', renderShippingDate);
  document.addEventListener('variant:change', renderShippingDate);
  document.addEventListener('product:variant-change', renderShippingDate);
  document.addEventListener('change', function (event) {
    var name = event.target && event.target.name;
    if (name === 'id' || name === 'options[]') window.setTimeout(renderShippingDate, 0);
  });

  var mutationObserver = new MutationObserver(function () {
    var node = document.querySelector('[data-hh-sg-date]');
    if (node && (!node.getAttribute('data-hh-sg-rendered') || /Beregner/i.test(node.textContent))) renderShippingDate();
  });
  mutationObserver.observe(document.body, { childList: true, subtree: true });
})();
